export default "__VITE_ASSET__BNqV9mlE__"